module.exports = __webpack_public_path__ + "static/media/creature-desk.a5002173.svg";